import axios from '@/api/requests/axios'

export default {
  getAllForRestaurant: params => axios.get('/api/admin/v1/menu-versions', { params }),
  sync: () => axios.put('/api/admin/v1/menu-versions/sync'),
  activate: menuVersion => axios.put('/api/admin/v1/menu-versions/activate', menuVersion),
}
